<script lang="ts">
	import { page } from '$app/state';
	import LanguageSelector from './components/LanguageSelector.svelte';
</script>

<div class="dark:bg-shade-background/50 flex items-center justify-center gap-4 p-4">
	<a class="anchor text-sm font-thin text-slate-400" href="/blog">Blog</a>
	<a class="anchor text-sm font-thin text-slate-400" href="/impressum">Impressum</a>
	<a class="anchor text-sm font-thin text-slate-400" href="/privacy">Privacy Policy</a>
	{#if page.data.locale}
		<LanguageSelector />
	{/if}
</div>
